import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Button from 'core/buttons/Button';
import PageContent from 'layouts/PageContent';

import { buildRoute } from 'routes';
import RolesAndPermission from 'components/role-and-permissions/RolesAndPermission';
import { resetCreate } from 'app/features/roles-and-permissions/roleAndPermissionsSlice';

function ListRolesAndPermission() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleAddRole = () => {
    dispatch(resetCreate());
    navigate(buildRoute('roles-and-permissions.create'));
  };

  return (
    <PageContent
      title="Roles"
      rightTopEndContent={
        <Button onClick={handleAddRole} startIcon={<AddIcon />}>
          ADD ROLE
        </Button>
      }
    >
      <RolesAndPermission />
    </PageContent>
  );
}

export default ListRolesAndPermission;